import React from 'react'
import './Tag.css'

export interface TagWithIconProps {
  label: string
  iconUrl?: string
  iconAlt?: string
  className?: string
}

export const TagWithIcon: React.FC<TagWithIconProps> = ({
  label,
  iconUrl,
  iconAlt,
  className = '',
}) => {
  return (
    <div className={`tag tag-with-icon ${className}`}>
      {iconUrl && (
        <img src={iconUrl} alt={iconAlt || `${label} icon`} className="tag-icon" />
      )}
      <span className="tag-label">{label}</span>
    </div>
  )
}
